<template>
    <div class="admin-card mb-32" @scroll="$emit('scroll')">
        <div class="d-flex">
            <div class="heading-3-gray-3 mb-24" v-if="title">
                {{ title }}
            </div>
            <tooltip v-if="tooltip" position="right" :tooltipClasses="''">
                <template #label>
                    <img class="information-icon" src="/imgs/icons/info_icon.svg"/>
                </template>

                <template #tooltip>
                    {{ tooltip }}
                </template>
            </tooltip>
        </div>
        <slot/>
    </div>
</template>

<script>
import Tooltip from './Tooltip';

export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        tooltip: {
            type: String,
            default: null
        },
    },
    components: {
        Tooltip
    },
};
</script>
